import { create } from "zustand";
import type { DockWidget } from "../types";

interface DockWidgetManagerState {
  widgets: Map<string, DockWidget>;
  /** Register (or replace) a dock widget. Idempotent by id. */
  registerWidget: (widget: DockWidget) => void;
  unregisterWidget: (id: string) => void;
  getWidget: (id: string) => DockWidget | undefined;
  getAllWidgets: () => DockWidget[];
}

export const useDockWidgetManager = create<DockWidgetManagerState>((set, get) => ({
  widgets: new Map(),

  registerWidget: (widget) => {
    set((state) => {
      const widgets = new Map(state.widgets);
      widgets.set(widget.id, widget);
      return { widgets };
    });
  },

  unregisterWidget: (id) => {
    set((state) => {
      if (!state.widgets.has(id)) return state;
      const widgets = new Map(state.widgets);
      widgets.delete(id);
      return { widgets };
    });
  },

  getWidget: (id) => get().widgets.get(id),
  getAllWidgets: () => Array.from(get().widgets.values()),
}));
